import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { AccountCircle as AccountCircleIcon } from "@mui/icons-material";
import { auth } from "marvin-auth-kit";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import axios from "axios";

export function AccountMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleLogout() {
    queryClient.clear();
    auth.logout();
    auth.ejectInterceptors(axios)
    navigate("/login");
  }
  return render();

  function render() {
    return (
      <>
        <IconButton aria-haspopup="true" onClick={handleMenu} color="default" size="large">
          <AccountCircleIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={handleClose}
        >
          <MenuItem disabled onClick={handleClose}>
            {t("label.myAccount")}
          </MenuItem>
          <MenuItem onClick={handleLogout}>{t("label.signOut")}</MenuItem>
        </Menu>
      </>
    );
  }
}
